import { getQueryStringObject } from './getQueryStringObject';
import { parseUserAgent } from './parseUserAgent';

export type ClientRefererObject = RefererObject | (RefererObject & UtmObject);

export interface RefererObject {
  referer: string;
  os: string;
  browser: string;
  queryParam: Record<string, unknown>;
  accessUrl: string;
  type: string;
}

export interface UtmObject {
  utmSource: string;
  utmCampaign: string;
  utmMedium: string;
  utmContent: string;
  utmTerm: string;
}

export const REFERER_TYPE = {
  SIGNUP: 'SIGNUP',
  NEW_LOGIN: 'NEW_LOGIN',
  LOGGED_IN: 'LOGGED_IN',
  TRY_SIGNUP: 'TRY_SIGNUP',
} as const;

export const USER_REFERER_KEY = '_ia';

export const clientUserRefererObjectString = () => {
  const { utm_source, utm_campaign, utm_medium, utm_content, utm_term, ...queryParam } =
    getQueryStringObject();
  const { os, browser } = parseUserAgent();

  const refererObject = {
    referer: document.referrer,
    accessUrl: location.href,
    os,
    browser,
    queryParam,
    utmSource: utm_source,
    utmCampaign: utm_campaign,
    utmMedium: utm_medium,
    utmContent: utm_content,
    utmTerm: utm_term,
  } as ClientRefererObject;

  return encodeURIComponent(JSON.stringify(refererObject));
};

const updateUserRefererObjectString = () => {
  const sessionReferer = sessionStorage.getItem(USER_REFERER_KEY);
  const clientReferer = clientUserRefererObjectString();

  const updated = sessionReferer === null || sessionReferer !== clientReferer;

  if (updated) {
    setClientUserReferObject(clientReferer);
  }

  return updated ? clientReferer : sessionReferer;
};

export const setClientUserReferObject = (referObjectString: string) => {
  sessionStorage.setItem(USER_REFERER_KEY, referObjectString);
};

/**
 * toSessionStorage: encodeURIComponent(JSON.stringify())
 * toObject: JSON.parse(decodeURIComponent())
 *
 * @returns ClientRefererObject
 */
export const getClientUserRefererObject = () => {
  const updatedReferObjectString = updateUserRefererObjectString();

  const refererObject = JSON.parse(
    decodeURIComponent(updatedReferObjectString),
  ) as ClientRefererObject;

  return refererObject;
};
